import React from 'react';

const Component = props => {
	return (
		<>
			<div className='pt-[5px]'>
				<h2 className='text-[36px] text-[#282e3f] mb-[25px]'>Droits des assurances et réparation du dommage</h2>
			</div>
			<div className='mt-[30px]'>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet d'avocats GAVA-<i>Lex</i> vous conseillera et vous défendra dans tous les dossiers de{' '}
					<strong>droit des assurances</strong> pour le règlement de vos litiges en cas de sinistre.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Il existe de nombreuses situations où l'assurance est obligatoire. Mais aussi des cas où se faire
					couvrir par une compagnie d'assurance reste facultatif. Quelque soit la situation, le cabinet vous
					accompagnera, que vous soyez l'assuré ou pas.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					En cas d'accident de la circulation, du travail ou autre, d'incendie, de faute professionnelle, ou
					de catastrophe naturelle, il arrive que la compagnie d'assurances refuse, totalement ou
					partiellement, d'intervenir. Parfois, il s'agit de l'assureur "défense en Justice" (ou "Protection
					juridique"). Le cabinet vous conseillera l'attitude à adopter.{' '}
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Nous nous occupons de tous les problèmes ayant trait aux assurances, quelles qu'elles soient : auto,
					incendie, vol, dégât des eaux, familiale - que la loi appelle dorénavant « vie privée » -, omnium,
					RC professionnelle, locative, vie, tout risque chantier, ou autres.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si le principe du dédommagement est acquis, le montant de l'<strong>indemnisation</strong> peut
					faire l'objet de contestation ou de discussion : estimation des dégâts, évaluation de tous les
					préjudices (matériel, blessures, dommage moral, préjudice économique, commercial, par répercussion,
					etc., éventuellement via expertise). Là aussi, le cabinet vous guidera et vous assistera.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si nécessaire, le cabinet vous accompagnera tout au cours de la procédure qui devrait être
					poursuivie pour faire valoir vos droits.
				</p>
				<div className='organigation-text w-[64%] col:float-none  col:w-full mt-[30px]'>
					<h2 className='text-[24px] text-[#282e3f] mb-[8px] block'>Aperçu des Cas Pratiques : </h2>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Litige entre assuré et assureur
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Accidents de la route et de vie privée
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Accident du travail
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Préjudice corporel et matériel
					</span>
				</div>
			</div>
		</>
	);
};

export default Component;
